// extracted by mini-css-extract-plugin
export default {"Details":"dg4UcYYwR6CFpH58GdnK","Details__icon_open":"u4eqyG4LX7OFttPPJinX","Details__icon_close":"crXaVthxR8_nBYwtzARj"};